import { Box, Divider, IconButton, Menu, Typography } from '@mui/material'
import React from 'react'
import '../../Pages/Devices/devices.css'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import { ArrowRightAlt, MenuOutlined, SubdirectoryArrowRight } from '@mui/icons-material'
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
const DeviceRow = ({ type, connectedDevices, el, i, setOpen, setTempEditData }) => {
  return (
    <>

      <div className='queuesContainer' >
        <Box sx={{ color: "black" }}>
          {
            <>

              <Accordion>
                <AccordionSummary>
                  <Box
                    sx={{
                      display: 'flex',
                      flexDirection: 'column' // Ensures horizontal layout
                    }}
                  >

                    <Typography display={"flex"} flexWrap={"wrap"} alignItems={"center"} gap={1} fontSize={20}>Device Name <ArrowRightAlt /> <strong>{el.name}({el.deviceCode})</strong></Typography>
                    <Typography
                      display="flex"
                      flexWrap="wrap"
                      alignItems="center"
                      gap={1}
                      fontSize={20}
                    >
                      Device Queue
                      <ArrowRightAlt />

                      <strong style={{ whiteSpace: "break-spaces" }}>
                        {el.queue}
                      </strong>

                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          navigator.clipboard.writeText(el.queue);
                        }}
                        onFocus={(e) => e.stopPropagation()}
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Typography>
                  </Box>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography>
                    {
                      connectedDevices && connectedDevices.length > 0 ? connectedDevices.map((dev, i) => {
                        return (<Typography display={"flex"} flexWrap={"wrap"} alignItems={"center"} gap={1} fontSize={15}><SubdirectoryArrowRight />  <strong style={{ whiteSpace: "break-spaces" }}>{dev.name} ({dev.deviceCode})</strong></Typography>)
                      }) : "No connections"
                    }
                  </Typography>
                </AccordionDetails>
              </Accordion>

            </>
          }</Box>
        <IconButton onClick={(event) => { setOpen(event.currentTarget); setTempEditData(el) }}><MenuOutlined sx={{ color: "black" }} /></IconButton>
      </div>
      <Divider />
    </>
  )
}

export default DeviceRow